import { useQuery } from "react-query";
import TrainingReportsService from "./TrainingReportsService";
import { Progress } from "antd";
import { useState } from "react";
const useTrainingReports = () => {
  const now = new Date();
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  const [fromDate, setFromDate] = useState(startOfMonth.toISOString());
  const [toDate, setToDate] = useState(endOfMonth.toISOString());
  const [planFromDate, setPlanFromDate] = useState(null);
  const [planToDate, setPlanToDate] = useState(null);

  const { data: trainingDetailsResponse, isLoading: loadingDetails } = useQuery(
    "trainingDetails",
    TrainingReportsService.getTrainingDetails
  );

  const trainingDetails = (trainingDetailsResponse?.data || []).sort((a, b) => {
    return new Date(b.endDate) - new Date(a.endDate);
  });

  // const filteredPlans = trainingDetails.map((item) => ({
  //   id: item.trainingId,
  //   trainingTitle: item.trainingTitle,
  //   startDate: item.startDate,
  //   endDate: item.endDate,
  //   progressInSessions: parseFloat(item.progressInSessions),
  //   status: item.status,
  //   quizProgress: item.quizProgress,
  // }));

  const {
    data: completionByMonthResponse = [],
    refetch: refetchCompletion,
    isLoading: loadingCompletionByMonth,
  } = useQuery(
    ["completionByMonth", fromDate, toDate],
    () => TrainingReportsService.getCompletionByMonth(fromDate, toDate),
    {
      enabled: !!fromDate && !!toDate,
    }
  );

  const completionByMonth = completionByMonthResponse?.data || [];

  const transformedCompletionByMonth = completionByMonth.map((item) => ({
    month: item.month,
    completed: item.completed.length,
    pending: item.pending.length,
  }));

  const {
    data: completionOverviewResponse = {},
    isLoading: loadingCompletionOverview,
  } = useQuery(
    "completionOverview",
    TrainingReportsService.getCompletionOverview
  );

  const completionOverview = completionOverviewResponse?.data || {};

  const { data: upcomingTrainingsResponse = {}, isLoading: loadingUpcoming } =
    useQuery("upcomingTrainings", TrainingReportsService.getUpcomingTrainings);

  const upcomingTrainings = upcomingTrainingsResponse?.data || [];
  const { data: averageDurationResponse, isLoading: loadingDuration } =
    useQuery("averageDuration", TrainingReportsService.getAverageDuration);
  const averageDuration = averageDurationResponse?.data || {};

  const filteredPlans = trainingDetails.filter((item) => {
    const start = new Date(item.startDate);
    const end = new Date(item.endDate);

    const isAfterStart = !planFromDate || new Date(planFromDate) <= end;
    const isBeforeEnd = !planToDate || new Date(planToDate) >= start;

    return isAfterStart && isBeforeEnd;
  });

  const planColumns = [
    {
      title: "Training Title",
      dataIndex: "trainingTitle",
      key: "trainingTitle",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (date) =>
        new Date(date).toLocaleDateString("en-GB", {
          year: "numeric",
          month: "short",
          day: "2-digit",
        }),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (date) =>
        new Date(date).toLocaleDateString("en-GB", {
          year: "numeric",
          month: "short",
          day: "2-digit",
        }),
    },
    {
      title: "Quiz Progress",
      dataIndex: "quizProgress",
      key: "quizProgress",
      render: (value) => {
        if (value === "No quiz") {
          return <span style={{ color: "#999" }}>No quizzes </span>;
        }
        return (
          <div style={{ width: "100px" }}>
            <Progress
              percent={parseFloat(value)}
              status={parseFloat(value) === 100 ? "success" : "active"}
            />
          </div>
        );
      },
    },
    ,
    {
      title: "Session Progress",
      dataIndex: "progressInSessions",
      key: "progressInSessions",
      render: (value) => (
        <div style={{ width: "100px" }}>
          <Progress
            percent={parseFloat(value)}
            status={parseFloat(value) === 100 ? "success" : "active"}
          />
        </div>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  const trainingCompletionData = [
    {
      name: "Completed",
      value: completionOverview.completedTrainings || 0,
    },
    {
      name: "Pending",
      value: completionOverview.pendingTrainings || 0,
    },
  ];

  const upcomingTrainingsColumns = [
    {
      title: "Training Title",
      dataIndex: "trainingTitle",
      key: "trainingTitle",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (date) =>
        new Date(date).toLocaleDateString("en-GB", {
          year: "numeric",
          month: "short",
          day: "2-digit",
        }),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (date) =>
        new Date(date).toLocaleDateString("en-GB", {
          year: "numeric",
          month: "short",
          day: "2-digit",
        }),
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Language",
      dataIndex: "language",
      key: "language",
      render: (lang) => lang.charAt(0).toUpperCase() + lang.slice(1),
    },
  ];

  return {
    trainingDetails,
    loadingDetails,
    completionOverview,
    loadingCompletionOverview,
    upcomingTrainings,
    loadingUpcoming,
    averageDuration,
    loadingDuration,
    completionByMonth,
    loadingCompletionByMonth,
    transformedCompletionByMonth,
    planColumns,
    filteredPlans,
    trainingCompletionData,
    upcomingTrainingsColumns,
    fromDate,
    toDate,
    setFromDate,
    setToDate,
    refetchCompletion,
    setPlanFromDate,
    setPlanToDate,
  };
};

export default useTrainingReports;
